import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getPoppularPlace } from './actions'


import {GridList, GridTile} from 'material-ui/GridList';
import {CardTitle} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';

import Paper from 'material-ui/Paper';
import SessionHeader from '../../components/SessionHeader/SessionHeader'
import ButtonFavorite from '../../components/ButtonFavorite'
import {
  addBookmark,
  deleteBookmark
} from '../Bookmark/actions'
import language from '../../config/language'

const styles = {
  root: {
    drootisplay: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    paddingBottom: 5
  },
  gridList: {
    width: '100%',
    overflowY: 'auto',
    margin: 0
  },
};

 export class PlacePopularContainer extends Component {
   static defaultProps = {
    getPoppularPlace: () => {},
    limit: 4,
    hiddenSeemore: false
   }
  componentDidMount() {
    this.props.getPoppularPlace()
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.props.lang) {
      this.props.getPoppularPlace()
    }
  }
  render() {
    const {
      title,
      seemore,
      loading
    } = language[this.props.lang].place.popular
    return (
      <Paper zDepth={1} style={{
          padding: 5,
          marginTop: 10,
        }}>
        <SessionHeader
          title={title}
          titleColor='#8BC34A'
          textSeemore={seemore}
          lineSeemore={'/home/place'}
          hiddenSeemore={this.props.hiddenSeemore}
        />
        {
          this.props.loading
          ? <p>{loading}</p>
          :
          <div style={styles.root}>
            <GridList
              cellHeight={115}
              style={styles.gridList}
              padding={10}
              cols={2}
            >
              {this.props.popular.slice(0, this.props.limit).map((tile) => (
                <GridTile
                  style={{ padding: 0, borderRadius: 3 }}
                  titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
                  // titleBackground="linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(255, 255, 255, 0)"
                  containerElement={<Link to={'/details/popularPlace/'+tile.id} />}
                  key={tile.img}
                  title={<b>{tile.title}</b>}
                  titleStyle={{ fontSize: 17 }}
                  subtitle={this.props.category.find(value => value.id === tile.category_id)['title_'+this.props.lang]}
                  actionIcon={
                    <ButtonFavorite
                      onClick={(event) => {
                        event.preventDefault()
                        this.props.bookmark.some(value => value.contentType === 'popularPlace' && value.contentId === tile.id)
                        ? this.props.deleteBookmark(this.props.bookmark.find(value => value.contentId === tile.id && value.contentType === 'popularPlace').id || '')
                        : this.props.addBookmark({
                            contentType: 'popularPlace',
                            contentId: tile.id
                          })
                      }}
                      isFollow={this.props.bookmark.some(value => value.contentType === 'popularPlace' && value.contentId === tile.id)}
                    />
                  }
                >
                  <img src={tile.cover_photo ? tile.cover_photo : ''} />
                </GridTile>
              ))}
            </GridList>
          </div>
        }
      </Paper>
    )
  }
}

const mapStateToProps = ({ lang, category, bookmark, ...state }) => ({
  popular: state.place.popular[lang].data,
  loading: state.place.popular.loading,
  lang,
  category,
  bookmark
})
export default connect(mapStateToProps, {
  getPoppularPlace,
  addBookmark,
  deleteBookmark
}
)(PlacePopularContainer)




// WEBPACK FOOTER //
// ./src/containers/Place/PlacePopularContainer.js